var _excluded = ["filterBy", "onFilter", "items", "scrollPositionKey", "sort", "sortOptions"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import orderBy from 'lodash.orderby';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import List from "./List";

var defaultProps = _objectSpread({}, List.defaultProps);

function SortableList(_ref) {
  var filterBy = _ref.filterBy,
      onFilter = _ref.onFilter,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? defaultProps.items : _ref$items,
      scrollPositionKey = _ref.scrollPositionKey,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? defaultProps.sort : _ref$sort,
      sortOptions = _ref.sortOptions,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(filterBy),
      _useState2 = _slicedToArray(_useState, 2),
      filter = _useState2[0],
      setFilter = _useState2[1];

  var _useState3 = useState(sort.property),
      _useState4 = _slicedToArray(_useState3, 2),
      sortProperty = _useState4[0],
      setSortProperty = _useState4[1];

  var _useState5 = useState(sort.ascending === undefined ? true : sort.ascending),
      _useState6 = _slicedToArray(_useState5, 2),
      ascending = _useState6[0],
      setAscending = _useState6[1];

  var properties = typeof sortProperty === 'string' ? [sortProperty] : sortProperty;
  var direction = properties === null || properties === void 0 ? void 0 : properties.map(function () {
    return ascending ? 'asc' : 'desc';
  });
  var itemsSorted = orderBy(filter && onFilter ? items.filter(function (item) {
    return onFilter(filter, item);
  }) : items, properties, direction);

  var handleSort = function handleSort(sortBy) {
    setSortProperty(sortBy === null || sortBy === void 0 ? void 0 : sortBy.property);
    setAscending(sortBy === null || sortBy === void 0 ? void 0 : sortBy.ascending);
  };

  return /*#__PURE__*/React.createElement(List, _extends({
    filter: filter,
    onFilter: onFilter && setFilter,
    onSort: sortOptions && handleSort,
    sort: {
      property: sortProperty,
      ascending: ascending
    },
    sortOptions: sortOptions,
    items: itemsSorted,
    flush: true,
    scrollPositionKey: scrollPositionKey
  }, props));
}

SortableList.displayName = "SortableList";
SortableList.propTypes = _objectSpread(_objectSpread({}, List.propTypes), {}, {
  filterBy: PropTypes.any
});
SortableList.defaultProps = defaultProps;
export default SortableList;